import React from 'react';
import PropTypes from 'prop-types';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import ActivationActionsContent
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioActivationAccountOpeningInterstitialTemplate/Content/ActivationActionsContent';

const ScenarioActivationAccountOpeningInterstitialTemplate = ({
  resource,
}) => {
  return (
    <MetaFormInline
      noIndividualSubmitButtons
      resource={resource}
      layout={ActivationActionsContent}
      margin={'none'}
      padding={'none'}
    />
  );
};

ScenarioActivationAccountOpeningInterstitialTemplate.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default ScenarioActivationAccountOpeningInterstitialTemplate;
